import { Component, OnDestroy, OnInit } from "@angular/core";
import { IRoleAdmin, ISubject } from "src/app/interfaces";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { NavigationService } from "src/app/services/navigation.service";
import { SubSink } from "subsink";
import { UserFacade } from "../services/user.facade";

@Component({
    selector: "admin-role",
    templateUrl: "./admin-role.html",
    standalone: false
})
export class AdminRoleComponent implements OnInit, OnDestroy {
  public roles: IRoleAdmin[];
  private subSink = new SubSink();
  constructor(
    private facade: UserFacade,
    private notificationFacade: NotificationFacade,
    public navService: NavigationService
  ) {}
  ngOnInit(): void {
    this.subSink.sink = this.facade
      .getRoles()
      .subscribe((role) => (this.roles = role));
  }

  save() {
    this.subSink.sink = this.facade.saveRoles(this.roles).subscribe(() => {
      this.subSink.sink = this.facade
        .getRoles()
        .subscribe((role) => (this.roles = role));
      this.notificationFacade.success("role.component.user.save.success");
    });
  }

  add() {
    const subjects = this.GetUncheckSubjects();
    this.roles.unshift({ id: 0, name: "", subjects: subjects });
  }

  delete(i: number) {
    this.roles.splice(i, 1);
  }

  private GetUncheckSubjects() {
    const subjects = [];
    this.roles[0].subjects.forEach((subject) => {
      const subjectNew: ISubject = {
        name: subject.name,
        actions: []
      };
      subject.actions.forEach((action) => {
        subjectNew.actions.push({
          name: action.name,
          checked: false
        });
      });
      subjectNew.actions.forEach((action) => (action.checked = false));
      subjects.push(subjectNew);
    });
    return subjects;
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
